import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=418266f9&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./ForgotPassword.vue?vue&type=style&index=0&id=418266f9&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "418266f9",
  null
  ,true
)

export default component.exports